import Sloth from 'slothd/dist/Sloth';

import 'slothd/dist/sass/';
import 'slothd/dist/Breadcrumb';
import 'slothd/dist/ListLink';
import 'slothd/dist/Pagination';
import 'slothd/dist/Article';
import 'slothd/dist/Carousel';
import 'slothd/dist/Tab';
import 'slothd/dist/Font';

import '../components/index';
import './main.scss';

import './List';
import './Home';
import './Courses';
import './Detail';


Sloth.init();



/** WEBPACK FOOTER **
 ** ./src/index.js
 **/